import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Validators } from '@angular/forms';

import { FieldBaseComponent } from '../field-component.base.component';

/** Number Field Component. */
@Component({
  selector: 'app-number-field',
  templateUrl: './number-field.component.html',
  styleUrls: ['./number-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class NumberFieldComponent extends FieldBaseComponent implements OnInit {
  /** Input element reference. */
  @ViewChild('input')
  inputElement: ElementRef;

  /** @inheritdoc */
  get errorMessage(): string {
    // super.errorMessage has pattern but it is for regex pattern
    // so this allows us to override that default error message.
    if (this.control().hasError('pattern')) {
      return this.translate.translate('INVALID_FIELD_NUMBER');
    }

    return super.errorMessage;
  }

  /** @inheritdoc */
  focus(): void {
    this.inputElement.nativeElement.focus();
    this.inputElement.nativeElement.select();
  }

  ngOnInit(): void {
    this.addValidators();
    this.control().addValidators(Validators.pattern('^-?[0-9]*$'));
    this.control().valueChanges.subscribe((newValue) => {
      if (!newValue) return; // Don't try to format if there is no value.
      // Returns only the integer.
      const truncatedValue = Math.trunc(newValue);
      this.control().setValue(truncatedValue, { emitEvent: false });
    });
  }

  /** @inheritdoc */
  onBlur(event: FocusEvent): void {
    if (!this.shouldBlur(event)) return;
    this.fieldBlurred.emit(this.field());
  }

  /** @inheritdoc */
  onFocus(): void {
    this.fieldFocused.emit(this.field());
  }

  onKeyPress(event: KeyboardEvent): void {
    if (event.key === '+' || event.key.toLowerCase() === 'e') {
      event.preventDefault();
    }
  }
}
